import Grid from "@mui/material/Grid";
import SettingEditorInstance from "../components/SettingEditorInstance";
import Container from "@mui/material/Container";

function SettingsOverview() {
  const settingKeys = [
    "chat-initial-message",
    "dont-understand-message",
    "dont-know-message",
    "forward-question-message",
    "general-error-message",
  ];

  return (
    <Container>
      {settingKeys.map((settingKey) => (
        <Grid item xs={12} key={settingKey}>
          <SettingEditorInstance settingKey={settingKey} />
        </Grid>
      ))}
    </Container>
  );
}

export default SettingsOverview;
